// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3PG13","inner":"Footer_inner__1ukcO"};